function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10,14 L10,9 L15,9 L15,11 L12,11 L12,14 L10,14 Z M10,7 L10,2 L12,2 L12,5 L15,5 L15,7 L10,7 Z M4,11 L1,11 L1,9 L6,9 L6,14 L4,14 L4,11 Z M4,5 L4,2 L6,2 L6,7 L1,7 L1,5 L4,5 Z"
});
function SvgExitFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitFullscreen);
export default __webpack_public_path__ + "static/media/exit-fullscreen.a623560b43c972721e4232ee405e6c4a.svg";
export { ForwardRef as ReactComponent };